export const splitToParagraphs = (text: string): string[] =>
  text
    .replace(/\r/g, '\n')
    .split('\n')
    .filter((paragraph) => paragraph.length > 0);
